import { Phone, Calculator } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CTABanner = () => {
  return (
    <section className="py-14 sm:py-20 bg-background text-foreground">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold mb-4 sm:mb-6">
          Need a Ride to Your Medical Appointment?
        </h2>
        <p className="text-base sm:text-lg md:text-xl opacity-90 max-w-2xl mx-auto mb-4 sm:mb-6">
          We're here to help. Call us now or request a ride online — it's simple and fast.
        </p>
        <div className="flex items-center justify-center gap-2 mb-8 sm:mb-10 text-primary">
          <Calculator className="h-5 w-5" />
          <span className="text-sm sm:text-base font-semibold" style={{ color: 'hsl(207, 90%, 38%)' }}>Instant price estimate available when you book online!</span>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
          <Button asChild size="lg" className="text-base sm:text-lg h-14 bg-button text-button-foreground hover:bg-button/90 shadow-lg transition-all duration-300 rounded-xl">
            <a href="tel:9713445446" className="flex items-center justify-center">
              <Phone className="h-5 w-5 mr-2" />
              Call or Text
            </a>
          </Button>
          <Button asChild size="lg" className="text-base sm:text-lg h-14 bg-button text-button-foreground hover:bg-button/90 shadow-lg transition-all duration-300 rounded-xl">
            <Link to="/contact#booking-form" className="flex items-center justify-center">
              <Calculator className="h-5 w-5 mr-2" />
              Get Instant Quote
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
